import React from 'react';
import {
  Box,
  Paper,
  Typography,
  IconButton,
  Tooltip,
  CircularProgress,
} from '@mui/material';
import {
  Delete,
  CheckCircle,
  Description,
  Image,
} from '@mui/icons-material';
import { FilePreviewProps } from './types';

export const FilePreview: React.FC<FilePreviewProps> = ({
  file,
  onRemove,
}) => {
  const getFileIcon = () => {
    if (file.file.type.startsWith('image/')) return <Image />;
    if (file.file.type.includes('pdf')) return <Description />;
    return <Description />;
  };

  const getStatusIcon = () => {
    switch (file.status) {
      case 'success':
        return <CheckCircle color="success" />;
      case 'uploading':
        return <CircularProgress size={16} />;
      default:
        return null;
    }
  };

  const formatFileSize = (bytes: number) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return (
    <Paper
      sx={{
        p: 2,
        mb: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        border: '1px solid #e0e0e0',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {getFileIcon()}
        {getStatusIcon()}
      </Box>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2" noWrap>
          {file.file.name}
        </Typography>
        <Typography variant="caption" color="textSecondary">
          {formatFileSize(file.file.size)} • {file.file.type}
        </Typography>
      </Box>

      <Tooltip title="Remove file">
        <IconButton
          size="small"
          onClick={() => onRemove(file.id)}
          color="error"
        >
          <Delete />
        </IconButton>
      </Tooltip>
    </Paper>
  );
}; 